import styled from 'styled-components';
import { colorBaseOrangePrimary } from 'haven-design-system/build/typescript/es6';

export const Container = styled.div`
  background-color: ${colorBaseOrangePrimary};
  height: 100px;
  width: 100px;
`;
